export const validNoticeAccountProductCode = [
  '570',
  '575',
  '585',
  '590',
  '720',
  '485',
  '705',
  '735',
  '484',
  '725',
  '730',
];
